import { render } from "./GuideItem.vue?vue&type=template&id=1c19e8ab&scoped=true"
import script from "./GuideItem.vue?vue&type=script&lang=js"
export * from "./GuideItem.vue?vue&type=script&lang=js"

import "./GuideItem.vue?vue&type=style&index=0&id=1c19e8ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c19e8ab"]])

export default __exports__